import React, { useState, useEffect, useCallback } from 'react';
import { LayoutGrid } from 'lucide-react';
import { Input } from './ui/input';
import axios from 'axios';
import { API } from '../config';

const LOCATION_LABELS = { city_centre: 'City Centre (Talbot St)', clarehall: 'Clarehall' };

const slotStyle = (count, capacity) => {
  if (count === 0) return 'bg-stone-100 text-stone-400 border-stone-200';
  if (count >= capacity) return 'bg-red-100 text-red-700 border-red-300';
  return 'bg-amber-50 text-amber-700 border-amber-300';
};

export const TableOccupancy = () => {
  const [date, setDate] = useState(() => new Date().toISOString().split('T')[0]);
  const [data, setData] = useState(null);

  const fetchOccupancy = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/occupancy`, { params: { date } });
      setData(res.data);
    } catch (err) {
      console.error('Failed to load occupancy:', err);
    }
  }, [date]);

  useEffect(() => { fetchOccupancy(); }, [fetchOccupancy]);

  return (
    <div className="bg-white rounded-xl p-4 shadow-sm mb-6" data-testid="table-occupancy">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div className="flex items-center gap-2">
          <LayoutGrid size={18} className="text-stone-500" />
          <h2 className="font-semibold text-stone-800">Table Occupancy</h2>
          <span className="text-xs text-stone-400">({data?.capacity || 3} tables per slot)</span>
        </div>
        <Input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="w-auto"
          data-testid="occupancy-date-input"
        />
      </div>
      {data && Object.entries(data.locations).map(([loc, slots]) => (
        <div key={loc} className="mb-3 last:mb-0">
          <p className="text-xs font-medium text-stone-500 uppercase tracking-wide mb-1.5">{LOCATION_LABELS[loc] || loc}</p>
          <div className="flex flex-wrap gap-1.5">
            {slots.map(({ time, count }) => (
              <div
                key={time}
                data-testid={`occupancy-slot-${loc}-${time}`}
                className={`px-2 py-1 rounded-lg border text-xs font-medium ${slotStyle(count, data.capacity)}`}
                title={`${count}/${data.capacity} tables booked`}
              >
                {time} <span className="font-semibold">{count}/{data.capacity}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
